// extracted by mini-css-extract-plugin
export default {"wrapper":"Step_wrapper__tGd0w"};